import React from "react";
import PropTypes from "prop-types";
import { Alert, IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import "./Alert.scss";

function CustomAlert({
  severity = "error",
  variant = "filled",
  title = "",
  description = "",
  action = null,
  close = false,
  onClose = () => {},
  className = "",
}) {
  return (
    <Alert
      severity={severity}
      variant={variant}
      className={`alert ${variant} ${severity} ${className}`}
      action={
        <>
          {action && <div className="alert-action">{action}</div>}
          {close && (
            <IconButton aria-label="close" onClick={onClose} className="alert-close-button">
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )}
        </>
      }
    >
      {title && <p className="heading-h4-medium">{title}</p>}
      {description && <span className="para-body-m-regular">{description}</span>}
    </Alert>
  );
}

CustomAlert.propTypes = {
  severity: PropTypes.oneOf(["error", "warning", "info", "success"]).isRequired,
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  action: PropTypes.node,
  close: PropTypes.bool,
  onClose: PropTypes.func,
};

CustomAlert.defaultProps = {
  variant: "filled",
  title: "",
  action: null,
  close: false,
  onClose: () => {},
};

export default CustomAlert;
